import styled from "@emotion/styled";
import TextareaAutosize from "react-textarea-autosize";
import { media } from "../Window/themes";
const MessageInput = {
    Textarea: styled(TextareaAutosize) `
    padding: 1em 2em;
    overflow: hidden;
    border: 0;
    height: unset;
    min-height: 3em;
    border-radius: 0.7em;
    color: ${({ theme }) => theme.color.text};
    background-color: ${({ theme }) => theme.color.inputBackground};
    caret-color: ${({ theme }) => theme.color.textMuted};
    resize: none;
    font-size: 16px !important;
    z-index: 7;
    &:focus {
      outline: none;
    }
    ::placeholder {
      color: ${({ theme }) => theme.color.textMuted};
    }
    ${media.medium} {
      height: 42px;
    }
  `,
    Wrapper: styled.div `
    position: relative;
    border-radius: 0.7em;
    margin: 1em 2em 0;
    color: ${({ theme }) => theme.color.text};
    background-color: ${({ theme }) => theme.color.inputBackground};
    display: grid;
    grid-template-columns: ${(props) => props.hasFile ? "1fr auto auto auto" : "1fr auto auto"};
    align-items: center;
    gap: 2px;
    ${media.medium} {
      margin: ${(props) => props.isVisible ? "1em 3em 0 2em" : "margin: 1em 2em 0"};
    }
  `,
    Btn: styled.button `
    height: 100%;
    background-color: ${({ theme }) => theme.color.inputBackground};
    cursor: pointer;
    border: none;
    border-radius: 0;
    border-left: 2px solid ${({ theme }) => theme.color.backgroundAccent};
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 7;
    svg {
      width: 18px;
      height: 18px;
    }
  `,
    SendIconWrapper: styled.button `
    height: 100%;
    background-color: ${({ theme }) => theme.color.inputBackground};
    cursor: pointer;
    border: none;
    border-radius: 0.7em;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 2px solid ${({ theme }) => theme.color.backgroundAccent};
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 7;
    svg {
      width: 18px;
      height: 18px;
    }
  `,
    EmojiContainer: styled.div `
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-101%);
    z-index: 1;
  `,
};
export default MessageInput;
//# sourceMappingURL=MessageInput.styled.js.map